import request from '../utils/require'
export function login(data) {
  return request({
    url: '/Login/login',
    method: 'post',
    data: data
  })
}
export function userLogOut() {
  return request({
    url: '/Login/loginOut',
    method: 'get',
  })
}
export function isRegister(data) {
  return request({
    url: '/Login/isRegister',
    method: 'post',
    data: data
  })
}
export function binding(data) {
  return request({
    url: '/Login/binding',
    method: 'post',
    data: data
  })
}
export function getWx(){
  return request({
    method:'GET',
    url:"/Login/get_data"
  })
}
export function userRegister(data){
  return request({
    url:"/Login/register",
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/services/home.js